import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMyFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.5 13.249a4.75 4.75 0 0 1 4.75 4.75v2a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-2a4.75 4.75 0 0 1 4.75-4.75zM12 2.05a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5"
  }));
}
var IcMyFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMyFill));

export { IcMyFill as I };
